import { useTranslation } from '@shared/core/i18n';

export const useCatalogRegistryTranslations = () => {
  const { t } = useTranslation('catalogRegistry');

  const addProductTranslations = t('addProduct');
  const getAddProductTranslations = () => {
    return {
      addToRegistry: addProductTranslations.addToRegistry(),
      notificationText: addProductTranslations.notificationText(),
      addToCart: addProductTranslations.addToCart(),
      addedToRegistry: addProductTranslations.addedToRegistry(),
      editGift: addProductTranslations.editGift(),
    };
  };

  const sidebarNavTranslations = t('sidebarNav');
  const getSidebarNavTranslations = () => {
    return {
      showAll: (categoryName: Maybe<string>) => {
        return sidebarNavTranslations.showAll({ categoryName });
      },
      back: sidebarNavTranslations.back(),
      shop: sidebarNavTranslations.shop(),
      departmentTitle: sidebarNavTranslations.departmentTitle(),
    };
  };

  const productDetailPageTranslations = t('productDetailPage');
  const getProductDetailPageTranslations = () => {
    return {
      soldBy: productDetailPageTranslations.soldBy(),
      fulfilledBy: productDetailPageTranslations.fulfilledBy(),
      buyNow: productDetailPageTranslations.buyNow(),
      joyExclusive: productDetailPageTranslations.joyExclusive(),
      quantity: productDetailPageTranslations.quantity(),
      whyWeLoveIt: productDetailPageTranslations.whyWeLoveIt(),
      specs: productDetailPageTranslations.specs(),
      description: productDetailPageTranslations.description(),
      viewDetails: productDetailPageTranslations.viewDetails(),
      buttonsDividerText: productDetailPageTranslations.buttonsDividerText(),
      returnTo: (title: Readonly<string>) => {
        return productDetailPageTranslations.returnTo({ title });
      },
      pleaseSelect: (label: Readonly<string>) => {
        return productDetailPageTranslations.pleaseSelect({ label });
      },
    };
  };

  const emptyCategoryContentTranslations = t('emptyCategoryContent');
  const getEmptyCategoryContentTranslations = () => {
    return {
      title: emptyCategoryContentTranslations.title(),
      subtitle: emptyCategoryContentTranslations.subtitle(),
      iosButton: emptyCategoryContentTranslations.iosButton(),
    };
  };

  const cashFundCatalogTranslations = t('cashFundCatalog');
  const getCashFundCatalogTranslations = () => {
    return {
      editAndAdd: cashFundCatalogTranslations.editAndAdd(),
      fundAddedTitle: (title: Maybe<string>) => {
        return cashFundCatalogTranslations.fundAddedTitle({ title });
      },
      fundSuccessSubtitle: cashFundCatalogTranslations.fundSuccessSubtitle(),
    };
  };

  return {
    getAddProductTranslations,
    getSidebarNavTranslations,
    getProductDetailPageTranslations,
    getEmptyCategoryContentTranslations,
    getCashFundCatalogTranslations,
  };
};

export const useCurationsRegistryTranslations = () => {
  const { t } = useTranslation('curationsRegistry');

  const curationsTranslations = t('curations');
  const getCurationsTranslations = () => {
    return {
      departmentTitle: curationsTranslations.departmentTitle(),
      defaultDepartmentTitle: curationsTranslations.defaultDepartmentTitle(),
    };
  };

  const sectionsTranslations = t('sections');
  const getSectionsTranslations = () => {
    return {
      exploreOthersTitle: sectionsTranslations.exploreOthersTitle(),
      addAll: sectionsTranslations.addAll(),
      addedAll: sectionsTranslations.addedAll(),
      addedAllToRegistry: sectionsTranslations.addedAllToRegistry(),
      addAllToRegistry: sectionsTranslations.addAllToRegistry(),
    };
  };

  return {
    getCurationsTranslations,
    getSectionsTranslations,
  };
};
